import { FC } from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import { CompleteDialog } from '../components/CompleteDialog'
import { ErrorDialog } from '../components/ErrorDialog'
import { Loading } from '../components/Loading'
import { useAuth } from '../hooks/useAuth'
import { Login } from '../pages/account/login'
import { ResendEmail } from '../pages/account/resendEmail'
import { ResetPassword } from '../pages/account/resetPassword'
import { SendEmail } from '../pages/account/sendEmail'
import { ShowMi } from '../pages/account/showMi'
import { Signup } from '../pages/account/signup'
import { ContractDetails } from '../pages/contracts/details'
import { Contracts } from '../pages/contracts/list'
import { Home } from '../pages/home'
import { NotFound } from '../pages/home/notFound'
import { Inquiry } from '../pages/inquiry'
import { WarrantyTerms } from '../pages/warrantyTerms'
import { idTokenState, requestState } from '../states/atoms'
import { ContractsPath, LoginPath, MiPath, ResendEmailPath, ResetPath, SendEmailPath, SignupPath } from './path'

export const AppRoute: FC = () => {
  const { idToken, isTokenRequested } = useRecoilValue(idTokenState)
  const [{ isLoading, completeMessage, errorMessage }, setRequestState] = useRecoilState(requestState)

  useAuth()

  const isConnectedFirebase = idToken

  if (!isTokenRequested) return <Loading />

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/inquiry/chat/:id" component={Inquiry} />
          <Route path="/warranty_terms" component={WarrantyTerms} />

          <Route exact path={MiPath} render={() => (isConnectedFirebase ? <ShowMi /> : <Redirect to={LoginPath} />)} />
          <Route path={SendEmailPath} component={SendEmail} />
          <Route path={SignupPath} component={Signup} />
          <Route path={LoginPath} render={() => (!isConnectedFirebase ? <Login /> : <Redirect to={ContractsPath} />)} />
          <Route path={ResendEmailPath} component={ResendEmail} />
          <Route path={ResetPath} render={() => <ResetPassword />} />
          <Route
            exact
            path={ContractsPath}
            render={() => (isConnectedFirebase ? <Contracts /> : <Redirect to={LoginPath} />)}
          />
          <Route
            path={ContractsPath + '/:id'}
            render={() => (isConnectedFirebase ? <ContractDetails /> : <Redirect to={LoginPath} />)}
          />
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </BrowserRouter>
      <CompleteDialog message={completeMessage ?? ''} onClose={() => setRequestState({ completeMessage: '' })} />
      <ErrorDialog message={errorMessage ?? ''} onClose={() => setRequestState({ errorMessage: '' })} />
      {isLoading && <Loading />}
    </>
  )
}
